module.exports = __webpack_public_path__ + "img/partner12.96408e69.png";